import { useCallback, useState } from "react";
import { useGomakeAxios } from "@/hooks";
import { useSnackBar } from "@/hooks/use-snack-bar";
import { markJobAsProofingJobApi } from "@/services/api-service/production-floor/production-floor-endpoints";

const useReturnProofJobToProofing = (defaultOnSuccess?: () => void) => {
  const { callApi } = useGomakeAxios();
  const { alertSuccessUpdate, alertFaultUpdate, alertFault } = useSnackBar();
  const [isReturning, setIsReturning] = useState(false);

  const returnProofJobToProofing = useCallback(
    (
      boardMissionId: string,
      onSuccess?: () => void
    ): Promise<boolean> => {
      if (!boardMissionId) {
        return Promise.resolve(false);
      }

      setIsReturning(true);

      return new Promise((resolve) => {
        markJobAsProofingJobApi(
          callApi,
          (res) => {
            setIsReturning(false);
            if (res?.success) {
              alertSuccessUpdate();
              (onSuccess ?? defaultOnSuccess)?.();
              resolve(true);
              return;
            }

            const errorMessage =
              res?.data?.ErrorMessage ||
              res?.data?.message ||
              (res as { message?: string })?.message ||
              (res as { msg?: string })?.msg;

            if (errorMessage) {
              alertFault(errorMessage);
            } else {
              alertFaultUpdate();
            }
            resolve(false);
          },
          { boardMissionId }
        ).catch(() => {
          setIsReturning(false);
          alertFaultUpdate();
          resolve(false);
        });
      });
    },
    [
      callApi,
      alertSuccessUpdate,
      alertFaultUpdate,
      alertFault,
      defaultOnSuccess,
    ]
  );

  return { returnProofJobToProofing, isReturning };
};

export { useReturnProofJobToProofing };
